import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-form-package/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Form, Field, Button } from '../src';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "form-validation"
    }}>{`Form Validation`}</h1>
    <p>{`Almost any form needs validation in some way. Fortunatly `}<inlineCode parentName="p">{`react-form-package`}</inlineCode>{` comes with an declarative inbuild validation system.`}</p>
    <p>{`What does decalrative mean in that way?`}</p>
    <h2 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h2>
    <p>{`If you want that your input field only allows valid emails you can add the type `}<inlineCode parentName="p">{`email`}</inlineCode>{` to the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component. If you also set `}<inlineCode parentName="p">{`validate`}</inlineCode>{` property on the `}<inlineCode parentName="p">{`<Form />`}</inlineCode>{` component the button only allowes to submit if the form is completely valid.`}</p>
    <p>{`In the next example you are able to submit the form if the input is empty (because this field is not required) and if the input value is set to a valid email, but not if the input value is not a valid email.`}</p>
    <Playground __position={0} __code={'<Form validate>\n  <div>\n    Email\n    <div>\n      <Field type=\"email\" id=\"email\" />\n    </div>\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Button,
      Playground
    }} mdxType="Playground">
  <Form validate mdxType="Form">
    <div>
      Email
      <div>
        <Field type="email" id="email" mdxType="Field" />
      </div>
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>
    <p>{`If you add the property `}<inlineCode parentName="p">{`required`}</inlineCode>{` to the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component, everything stays the same except that you are not able to submit the form if the input value is empty.`}</p>
    <Playground __position={1} __code={'<Form validate>\n  <div>\n    Email\n    <div>\n      <Field type=\"email\" id=\"email\" required />\n    </div>\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Button,
      Playground
    }} mdxType="Playground">
  <Form validate mdxType="Form">
    <div>
      Email
      <div>
        <Field type="email" id="email" required mdxType="Field" />
      </div>
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>
    <h2 {...{
      "id": "type-validation"
    }}>{`Type validation`}</h2>
    <p>{`A `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component can have diffferent `}<inlineCode parentName="p">{`type`}</inlineCode>{` properties.`}</p>
    <p>{`Additionally to the validation, if the browser supports HTML5 input types the input fields will be displayed as them, only allowing numbers by default if the type is set to `}<inlineCode parentName="p">{`number`}</inlineCode>{`, etc. If the browser does not support HTML5 it will automatically uses a text input that keeps the validation. If the user inputs a non numeric character in a `}<inlineCode parentName="p">{`number`}</inlineCode>{` input it will display the the error message and you cannot submit the form.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`checkbox`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`no`}</inlineCode>{` additional validation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the format `}<inlineCode parentName="td">{`YYYY-MM-DD`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`textarea`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`no`}</inlineCode>{` additional validation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`datetime-local`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the format `}<inlineCode parentName="td">{`YYYY-MM-DDTHH:MM`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`email`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the `}<inlineCode parentName="td">{`standard email format`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches a `}<inlineCode parentName="td">{`valid number`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`tel`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the `}<inlineCode parentName="td">{`standard phone number format`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`no`}</inlineCode>{` additional validation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`password`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`no`}</inlineCode>{` additional validation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`time`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the format `}<inlineCode parentName="td">{`HH:MM`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the `}<inlineCode parentName="td">{`standard url format`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`file`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`no`}</inlineCode>{` additional validation`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "additional-rules"
    }}>{`Additional rules`}</h2>
    <p>{`If you are using a `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{` component you can also add some additional rules for the validation.
`}<inlineCode parentName="p">{`required`}</inlineCode>{` will work on all components, the `}<inlineCode parentName="p">{`<Field />`}</inlineCode>{`, the `}<inlineCode parentName="p">{`<RadioGroup />`}</inlineCode>{`, and the `}<inlineCode parentName="p">{`<Select />`}</inlineCode></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`required`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bool`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the `}<inlineCode parentName="td">{`input value is not empty`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`min`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String (digit or date (YYYY-MM-DD))`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: validates if the input value is at least `}<inlineCode parentName="td">{`min characters long`}</inlineCode>{`; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: validates if the input value is at least `}<inlineCode parentName="td">{`min`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`max`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String (digit or date (YYYY-MM-DD))`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`text`}</inlineCode>{`, `}<inlineCode parentName="td">{`textarea`}</inlineCode>{`, `}<inlineCode parentName="td">{`password`}</inlineCode>{`: validates if the input value is maximum `}<inlineCode parentName="td">{`max characters long`}</inlineCode>{`; `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`date`}</inlineCode>{`: validates if the input value is maximum `}<inlineCode parentName="td">{`max`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`match`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`validates if the input value matches the `}<inlineCode parentName="td">{`regular expression`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sameAs`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{` validates if the input of this field has the same value as the field specified in `}<inlineCode parentName="td">{`sameAs`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`validate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Func`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{` a function that gets access to the value of the field `}<inlineCode parentName="td">{`(value) => // write your own validation`}</inlineCode>{` (do not forget to write your own errorMessage)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Example with the `}<inlineCode parentName="p">{`required`}</inlineCode>{`, `}<inlineCode parentName="p">{`min`}</inlineCode>{`, `}<inlineCode parentName="p">{`max`}</inlineCode>{`, `}<inlineCode parentName="p">{`validate`}</inlineCode>{`, and `}<inlineCode parentName="p">{`sameAs`}</inlineCode>{` properties:`}</p>
    <Playground __position={2} __code={'<Form validate>\n  <div>\n    Text required, min, max\n    <div>\n      <Field type=\"text\" id=\"text\" min=\"2\" max=\"5\" required />\n    </div>\n  </div>\n  <div>\n    Number required, min, max\n    <div>\n      <Field type=\"number\" id=\"number\" min=\"2\" max=\"5\" required />\n    </div>\n  </div>\n  <div>\n    Text is required and has to validate the `validate` function (value ===\n    \'react\')\n    <div>\n      <Field\n        type=\"text\"\n        id=\"validate\"\n        validate={value => value === \'react\'}\n        errorMessage={\n          \'This field is required\\\\nThis field has to match \"react\"\'\n        }\n        required\n      />\n    </div>\n  </div>\n  <div>\n    Date required, min, max\n    <div>\n      <Field\n        type=\"date\"\n        id=\"date\"\n        min=\"2018-12-12\"\n        max=\"2018-12-24\"\n        required\n      />\n    </div>\n  </div>\n  <div>\n    Password has to be the same as password 2\n    <div>\n      <Field type=\"password\" id=\"password\" sameAs=\"password2\" required />\n    </div>\n  </div>\n  <div>\n    Password 2 has to be the same as password\n    <div>\n      <Field type=\"password\" id=\"password2\" sameAs=\"password\" required />\n    </div>\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Button,
      Playground
    }} mdxType="Playground">
  <Form validate mdxType="Form">
    <div>
      Text required, min, max
      <div>
        <Field type="text" id="text" min="2" max="5" required mdxType="Field" />
      </div>
    </div>
    <div>
      Number required, min, max
      <div>
        <Field type="number" id="number" min="2" max="5" required mdxType="Field" />
      </div>
    </div>
    <div>
      Text is required and has to validate the `validate` function (value === 'react')
      <div>
        <Field type="text" id="validate" validate={value => value === 'react'} errorMessage={'This field is required\\nThis field has to match "react"'} required mdxType="Field" />
      </div>
    </div>
    <div>
      Date required, min, max
      <div>
        <Field type="date" id="date" min="2018-12-12" max="2018-12-24" required mdxType="Field" />
      </div>
    </div>
    <div>
      Password has to be the same as password 2
      <div>
        <Field type="password" id="password" sameAs="password2" required mdxType="Field" />
      </div>
    </div>
    <div>
      Password 2 has to be the same as password
      <div>
        <Field type="password" id="password2" sameAs="password" required mdxType="Field" />
      </div>
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>
    <p>{`Example with the match property:`}</p>
    <Playground __position={3} __code={'<Form validate>\n  <div>\n    Text required and has to match \"react\"\n    <div>\n      <Field type=\"text\" id=\"text\" match={/react/} required />\n    </div>\n  </div>\n  <div>\n    <Button\n      type=\"submit\"\n      id=\"submit\"\n      onClick={state => {\n        alert(JSON.stringify(state, null, 2))\n        alert(\'open the console to see the whole state...\')\n        console.log(state)\n      }}\n    >\n      Submit\n    </Button>\n  </div>\n</Form>'} __scope={{
      props,
      DefaultLayout,
      Form,
      Field,
      Button,
      Playground
    }} mdxType="Playground">
  <Form validate mdxType="Form">
    <div>
      Text required and has to match "react"
      <div>
        <Field type="text" id="text" match={/react/} required mdxType="Field" />
      </div>
    </div>
    <div>
      <Button type="submit" id="submit" onClick={state => {
            alert(JSON.stringify(state, null, 2));
            alert('open the console to see the whole state...');
            console.log(state);
          }} mdxType="Button">
        Submit
      </Button>
    </div>
  </Form>
    </Playground>
    <p>{`This is just a simple example, off course you are able to pass any regular expression you would like. If you would like to customize the error messages take a look at `}<a parentName="p" {...{
        "href": "/react-form-package/custom-error-messages"
      }}>{`custom error messages`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      